import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import adicionarFiltroPedido from '../../actions/pedido/adicionarFiltroPedido'
import removerFiltroPedido from '../../actions/pedido/removerFiltroPedido'
import CampoBusca from '../comum/CampoBusca'

export class CampoBuscaPedidos extends Component {
  render () {
    return (
      <React.Fragment>
        <CampoBusca
          filtrosAdicionados={this.props.filtrosAdicionadosProcesso}
          adicionarFiltro={this.props.adicionarFiltroPedido}
          removerFiltro={this.props.removerFiltroPedido}/>
      </React.Fragment>
    )
  }
}

export const mapStateToProps = ({ filtrosAdicionadosProcesso }) => ({ filtrosAdicionadosProcesso });

export const mapDispatchToProps = dispatch => bindActionCreators({
  adicionarFiltroPedido,
  removerFiltroPedido
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(CampoBuscaPedidos)
